/**
 * Created by mukund on 8/24/17.
 */

angular.module('mediacloudApp')
    .directive('collectionContent', ['$http', '$timeout', 'AssetService', 'ResponsivenessService', 'Principal', 'BaseFileService', 'CollectionService', '$state', function($http, $timeout, AssetService, ResponsivenessService, Principal, BaseFileService, CollectionService, $state){
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/collection/directives/collection-content/collection-content.html',
            scope: {
                islmscourse: '=',
                activeview: '=',
                currentcollection: '=',
                content: '=',
                featured: '=',
                isCourseContent: '=',
                showsearchresults: '=',
                openContent: '&',
                manageCheckAllState: '='
            },
            link: function(scope, element, attrs){
                var userInfo = Principal.getUserInfo();
                scope.userName = userInfo.userName;
                scope.userFullName = userInfo.userFullName;
                scope.selected = {};
                scope.hasWritePermissions = (
                    scope.$parent.hit ?
                        scope.$parent.hit.acl.indexOf('W') !== -1 :
                        scope.$parent.parentCollection.acl.indexOf('W') !== -1) && scope.$parent.$parent.enableContentManagement;

                scope.hasWriteInACL = (
                    scope.$parent.hit ?
                        scope.$parent.hit.acl.indexOf('W') !== -1 :
                        scope.$parent.parentCollection.acl.indexOf('W') !== -1);

                scope.isStudent =
                    scope.$parent.hit ? scope.$parent.hit.acl.indexOf('R') > -1
                        && scope.$parent.hit.acl.indexOf('W') === -1
                        &&  scope.userName.length > 0
                    : scope.$parent.parentCollection.acl.indexOf('W') === -1
                        && scope.$parent.parentCollection.acl.indexOf('R') > -1
                        && scope.userName !== 'anonymousUser';

                 scope.enableQuizzing = false;

                 console.log('content: ', scope.content);
                 scope.content.quizAvailability = false;
                 scope.content.showViewResults = false;
                 if (scope.content.type == 'Quiz') {
                     $http({
                         method: 'GET',
                         url: 'api/quiz/getQuizAvailability?cid=' + scope.content.parent.cid + '&aid=' + scope.content.xid
                     }).then(function successCallback(response) {
                         scope.content.quizAvailability = response.data.available;
                         scope.content.quizId = response.data.quizId;
                         scope.content.showViewResults = response.data.showViewResults;
                         scope.content.numResults = response.data.numResults;
                         scope.content.currentUserSubmissions = response.data.currentUserSubmissions;
                     });
                 }

                 scope.handleRedirectToResults = function() {
                     $state.go("quizzingReportStudent", {
                         collectionId: scope.content.parent.cid,
                         assetId: scope.content.xid,
                         quizId: scope.content.quizId,
                         showResyncButton: false,
                         isPreview: false, // not possible to be in preview mode from collection content
                     });
                 };

                 $http({
                     method: 'GET',
                     url: 'api/properties?name=ENABLE_QUIZZING'
                 }).then(function successCallback(response) {
                     scope.enableQuizzing = response.data.value === "true";

                     if (response.data.value === "admin") {
                         var isQuizzingAdmin = Principal.hasAnyAuthority(["ROLE_QUIZZING_ADMIN"]);
                         if (isQuizzingAdmin) {
                             scope.enableQuizzing = true;
                         }
                     }
                 });

                scope.canEdit = scope.$parent.canEdit;

                //This is the regular instructor, with Content Manager privileges
                // scope.isInstructor = (scope.$parent.hit ? scope.$parent.hit.acl.indexOf('W') > -1 : scope.$parent.parentCollection.acl.indexOf('W') > -1) && scope.$parent.isContentManager && scope.$parent.enableContentManagement;
                scope.isInstructor = (scope.$parent.hit ? scope.$parent.hit.acl.indexOf('W') > -1 : scope.$parent.parentCollection.acl.indexOf('W') > -1) && scope.$parent.enableContentManagement;

                //This is the instructor without the Content Manager privileges
                scope.isInstructorNoCM = (scope.$parent.hit ? scope.$parent.hit.acl.indexOf('W') > -1 : scope.$parent.parentCollection.acl.indexOf('W') > -1) && !scope.$parent.enableContentManagement;
                scope.showTitleTooltip = true;
                scope.showDescriptionTooltip = false;
                scope.unpublished = scope.$parent.$parent.unpublished;

                scope.$watch('render', function(){
                    runAfterElementIsLoaded(['div.asset-title:not(.asset-title-no-hover)', 'p.description'], getFeatureFlagShowMoreTooltip);
                });

                var runAfterElementIsLoaded = function(selectors, callback) {
                    var interval1Id = setInterval(() => {

                        if( $(element).find(selectors[0]).length ) {
                            clearInterval(interval1Id);

                            var interval2Id = setInterval(() => {
                                if($(element).find(selectors[1]).length){
                                    clearInterval(interval2Id);
                                    callback();
                                }
                            }, 100)
                        }
                    }, 100)
                }

                  let closePromise;

                  scope.isTooltipOpen = false;

                  scope.openTooltip = function() {
                    scope.isTooltipOpen = true;
                  };

                  scope.scheduleCloseTooltip = function() {
                    closePromise = $timeout(function() {
                      scope.isTooltipOpen = false;
                    }, 300); // Delay to allow user to move cursor
                  };

                  scope.cancelCloseTooltip = function() {
                    if (closePromise) {
                      $timeout.cancel(closePromise);
                    }
                  };

                scope.viewQuizReport = function () {
                    $state.go("quizzingReportInstructor", {
                        collectionId: scope.content.parent.cid,
                        assetId: scope.content.xid,
                        quizId: scope.content.quizId,
                    });
                };

                scope.handleMenuViewQuizReportKeyPress = function(e) {
                    if(e.which === 13 || e.which === 32) {
                        scope.viewQuizReport();
                    }
                }

                scope.handleQuizAvailabilitySwitchClick = function (e) {
                   scope.content.quizAvailability = !scope.content.quizAvailability;
                   var quizPublishDTO = {
                        assetId: scope.content.xid,
                        collectionId: scope.content.parent.cid,
                        makeAvailable: scope.content.quizAvailability,
                    };
                    AssetService.PublishQuiz.send(quizPublishDTO, function (resp) {
                        console.log('making quiz available: ', resp);
                    });
                }

                scope.handleQuizAvailabilitySwitchKeyPress = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleQuizAvailabilitySwitchKeyPress');
                    }
                    if(e.which === 13) {
                        scope.handleQuizAvailabilitySwitchClick(e);
                    }
                }

                var getFeatureFlagShowMoreTooltip = function() {
                    $http({
                        method: 'GET',
                        url: 'api/properties?name=FEATURE_FLAG_SHOW_MORE_TOOLTIP'
                    }).then(function successCallback(response) {
                        if (response.data.value != null) {
                            scope.hasEllipsisInTitle = hasEllipsis('title');
                            scope.hasEllipsisInDescription = hasEllipsis('description');

                            var flagShowMoreTooltip = response.data.value === 'true' ? true : false;
                            scope.flagShowMoreTooltip = flagShowMoreTooltip;
                            manageTitleTooltip(flagShowMoreTooltip);
                            manageDescriptionTooltip(flagShowMoreTooltip);
                        }
                    });
                }

                var manageTitleTooltip = function(flagShowMoreTooltip) {
                    if(scope.hasEllipsisInTitle) {
                        scope.showTitleTooltip = scope.isStudent;

                        if (!scope.isStudent) {
                            if (flagShowMoreTooltip) {
                                scope.showTitleTooltip = scope.isInstructorNoCM;
                            }
                        }
                    } else {
                        scope.showTitleTooltip = false;
                    }
                }

                var manageDescriptionTooltip = function(flagShowMoreTooltip) {
                    if(scope.hasEllipsisInDescription) {
                        scope.showDescriptionTooltip = scope.isStudent;

                        if(!scope.isStudent) {
                            if (flagShowMoreTooltip) {
                                scope.showDescriptionTooltip = scope.isInstructorNoCM;
                            }
                        }
                    } else {
                        scope.showDescriptionTooltip = false;
                    }
                }

                var hasEllipsis = function(field) {
                    var fieldSelector, scrollLength, offsetLength;

                    if(field === 'title') {
                        fieldSelector = 'div.asset-title:not(.asset-title-no-hover)';
                    } else if (field === 'description') {
                        fieldSelector = 'p.description';
                    }

                    var contentElement = $(element)[0].querySelector(fieldSelector);

                    if(field === 'title') {
                        scrollLength = contentElement && contentElement.scrollWidth;
                        offsetLength = contentElement && contentElement.offsetWidth;
                    } else if (field === 'description') {
                        scrollLength = contentElement && contentElement.scrollHeight;
                        offsetLength = contentElement && contentElement.offsetHeight;
                    }

                    return scrollLength > offsetLength;
                };

                scope.toggleFavorite = function(content){
                    if(scope.logEventHandlers) {
                        console.log('toggleFavorite')
                    }
                    var isFavorite = content.isFavorite;
                    AssetService.toggleAssetFavorite(content, content.xid, content.parent.cid)
                        .then(function(response){
                            if(response.result){
                                content.isFavorite = !isFavorite;
                            }
                        }).catch(function(err) {
                            scope.error = err;
                        });
                };

                scope.cardBgColorOnFocus = '#F0F8FF';
                scope.inputBgColorOnFocus = '#FFFFFF';

                ResponsivenessService.makePnPThumbnailsResponsive();

                scope.isPersistingDescription = false;

                var generateCrumbs = function (cid, path) {
                    if(scope.logEventHandlers) {
                        console.log('generateCrumbs')
                    }
                    var crumbs = [];
                    if (path) {
                        var parents = path.split('/').slice(3);
                        if (parents.length) {
                            angular.forEach(scope.$parent.$parent.collectionTree.children, function (node) {
                                getCrumbs(node, crumbs, cid, parents);
                            });
                        }
                    }
                    return crumbs;
                };

                // recursive function that gets all parent nodes of a collection from the collection tree
                var getCrumbs = function (node, crumbs, cid, parents) {
                    if(scope.logEventHandlers) {
                        console.log('getCrumbs')
                    }

                    if (node.cid && parents.indexOf(node.cid) !== -1) {
                        crumbs.push({title: node.title, cid: node.cid});
                    }
                    angular.forEach(node.children, function (child) {
                        getCrumbs(child, crumbs, cid, parents);
                    });
                };

                scope.persistDescription = function (e) {
                    if(scope.logEventHandlers) {
                        console.log('persistDescription')
                    }
                    if(e.which === 13) {
                        scope.isPersistingDescription = true;
                        var descriptionValue = removeHTMLTags(e.target.value.trim());
                        scope.content.description = descriptionValue;

                        var updateItem = new BaseFileService.UpdateItem({
                            collectionContentDTO: scope.content,
                            destinationCollectionId: scope.content.parent.cid
                        });

                        updateItem.$save(function (response) {
                            console.log('updateItem resp: ', response);
                            CollectionService.GetCollectionTree.get({cid: scope.currentcollection.cid}, function (tree) {
                                scope.$parent.$parent.collectionTree = tree;
                                scope.$parent.$parent.collectionTree.show = false;
                                scope.$parent.$parent.currentCollection.crumbs = generateCrumbs(scope.currentcollection.cid, scope.currentcollection.path);
                                if(scope.currentcollection.pathLength >= 3){
                                    $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "40%"});
                                } else {
                                    $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "95%"});
                                }
                            });
                        }, function () {
                        });

                        var el = e.target;
                        var descriptionField = el;
                        var descriptionText = el.parentElement.querySelector('p.description');
                        var descriptionTextNoHover = el.parentElement.querySelector('p.description-no-hover');
                        var descriptionDisplayValue = descriptionValue.trim().length ? descriptionValue : 'Enter a description';

                        //hide hover
                        descriptionText.style.display = 'none';
                        descriptionText.innerHTML = descriptionDisplayValue;

                        //hide textarea
                        descriptionField.style.background = '#FFFFFF';
                        descriptionField.style.display = 'none';

                        //display description no hover
                        descriptionTextNoHover.innerHTML = descriptionDisplayValue;
                        descriptionTextNoHover.classList.remove('ng-hide');
                        descriptionTextNoHover.style.display = '';

                        setTimeout(function(){
                            scope.isPersistingDescription = false;
                        }, 1000)

                        e.preventDefault();
                    }
                }

                scope.isPersistingTitle = false;

                scope.handleTitleInputKeyPress = function(e) {
                    if (scope.logEventHandlers) {
                        console.log('handleTitleInputKeyPress')
                    }
                    if (e.which === 13) {
                        e.preventDefault();
                        scope.persistTitle(e.target, false);
                    }
                }

                function pad(d) {
                    return (d < 10) ? '0' + d.toString() : d.toString();
                }

                var removeHTMLTags = function(value) {
                    var processedText = value.replaceAll('<', '&lt;')
                    processedText = processedText.replaceAll('>', '&gt;')
                    return processedText;
                }

                scope.persistTitle = function(titleField, isNewFolderVisible) {
                    if(scope.logEventHandlers) {
                        console.log('persistTitle')
                    }

                    var el = titleField;
                    el.value = el.value.trim();
                    var titleValue = el.value.length ? el.value : (scope.content.type === 'Collection' ? 'Untitled Folder' : 'Untitled Asset');
                    titleValue = removeHTMLTags(titleValue);

                    var untitled;

                    // Count the Untitled Items
                    if(titleValue === 'Untitled Folder' || titleValue === 'Untitled Asset') {
                        var countFolders = 1;
                        var countAssets = 1;

                        $.each(scope.currentcollection.contents, function (k, v) {
                            if (v.title.includes('Untitled Folder')) {
                                countFolders++;
                            }

                            if (v.title.includes('Untitled Asset')) {
                                countAssets++;
                            }
                        });

                        var numFolders = pad(countFolders);
                        var numAssets = pad(countAssets);

                        if(titleValue === 'Untitled Folder') {
                            untitled = numFolders != '01' ? 'Untitled Folder ' + numFolders : 'Untitled Folder';
                        }

                        if(titleValue === 'Untitled Asset') {
                            untitled = numAssets != '01' ? 'Untitled Asset ' + numAssets : 'Untitled Asset';
                        }
                    }

                    var newTitle = untitled ? untitled : titleValue;

                    var collectionContentDTO;
                    if(isNewFolderVisible) {
                        newTitle = newTitle.indexOf('Untitled Asset') > -1 ? 'Untitled Folder' : newTitle;
                        //persist new folder title
                        collectionContentDTO = {
                            description: '',
                            title: newTitle,
                            type: 'Collection',
                            xid: 'Collection Created'
                        }
                    } else {
                        //persist the current item title
                        scope.content.title = newTitle;
                        collectionContentDTO = scope.content;
                    }

                    scope.isPersistingTitle = true;

                    var updateItem = new BaseFileService.UpdateItem({
                        collectionContentDTO: collectionContentDTO,
                        destinationCollectionId: scope.content.parent.cid
                    });

                    updateItem.$save(function (response) {
                        console.log('updateItem resp: ', response);

                        CollectionService.GetCollectionTree.get({cid: scope.currentcollection.cid}, function (tree) {
                            scope.$parent.$parent.collectionTree = tree;
                            scope.$parent.$parent.collectionTree.show = false;
                            scope.$parent.$parent.currentCollection.crumbs = generateCrumbs(scope.currentcollection.cid, scope.currentcollection.path);
                            if(scope.currentcollection.pathLength >= 3){
                                $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "40%"});
                            } else {
                                $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "95%"});
                            }
                        });
                    }, function () {});

                    //assign new value to input
                    $(el).val(newTitle);

                    //hide title
                    $(el).parent().find('div.asset-title').text(newTitle);
                    $(el).parent().find('div.asset-title').hide();

                    //hide input
                    $(el).hide();

                    //show title no hover
                    var titleTextNoHover;
                    if(el.parentElement.querySelector('div.asset-title-no-hover')) {
                        titleTextNoHover = el.parentElement.querySelector('div.asset-title-no-hover');
                    } else if(el.parentElement.querySelector('div.folder-title-no-hover')) {
                        titleTextNoHover = el.parentElement.querySelector('div.folder-title-no-hover');
                    }

                    if(titleTextNoHover) {
                        titleTextNoHover.innerHTML = newTitle;
                        titleTextNoHover.classList.remove('ng-hide');
                        titleTextNoHover.style.display = '';
                    }

                    setTimeout(function() {
                        scope.isPersistingTitle = false;
                    }, 1000)
                }

                scope.menuMove = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('menuMove')
                    }
                    //select item's checkbox
                    var xid = $($($(e.target).parents('.item')[0]).children()[0]).data('xid');
                    //open modal to move
                    scope.openModal('Move', xid);
                }

                scope.menuCopy = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('menuCopy')
                    }

                    var xid = $($($(e.target).parents('.item')[0]).children()[0]).data('xid');

                    //open modal to copy
                    scope.openModal('Copy', xid);
                }

                scope.createQuiz = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('createQuiz')
                    }
                    var newQuizMM = {
                        cid: scope.$parent.$parent.currentCollection.cid,
                        parentAssetId: scope.content.xid,
                    }
                    AssetService.NewQuizMM.send(newQuizMM, function (response) {
                        scope.quizAid = response.aid;
                        scope.quizCid = response.cid;
                        var newQuizMC = {
                            collectionId: response.cid,
                            assetId: response.aid,
//                            token: $rootScope.launchToken,
//                            state: $rootScope.launchState
                        }
                        AssetService.CreateQuiz.send(newQuizMC, function (response) {
                            var addQuizSettings = {
                                quizId: response.id,
                                allowSkipping: false,
                                allowChanges: false,
                                shuffleAnswers: false,
                                showCorrectAnswer: false,
                                showFeedbackAnswerSubmission: false,
                                showResultsQuizSubmission: false,
                                answerSubmissions: '0',
                                quizSubmissions: '1'
                            }
                            AssetService.AddQuizSettings.send(addQuizSettings, function (response) {
                                $state.go('quizzing', {
                                    collectionId: scope.quizCid,
                                    assetId: scope.quizAid,
                                    collectionType: scope.$parent.$parent.currentCollection.type,
                                    isNewQuiz: true,
                                    isFromPnP: false
                                });
                            });
                        });
                    });
                }

                var modalConfirmSingle = function(callback){
                    if(scope.logEventHandlers) {
                        console.log('modalConfirmSingle')
                    }

                      $("#delete-item-single").on("click", function(){
                        callback(true);
                        $("#delete-modal-single").modal('hide');
                      });

                      $("#modal-btn-close-single").on("click", function(){
                        $("#delete-modal-single").modal('hide');
                      });
                };

                modalConfirmSingle(function(confirm){
                  if(confirm && scope.selected.target){
                    scope.menuDelete(scope.selected);
                  }
                });


                scope.confirmDelete = function (e) {
                    if(scope.logEventHandlers) {
                        console.log('confirmDelete')
                    }
                    var title = scope.content.title;
                    var modalHeadline = "";
                    var modalBody = "";
                    if("Quiz" === scope.content.type){
                        modalHeadline = "Delete Published Quiz?";
                        if(!scope.unpublished){
                            modalBody = "This quiz is published, i.e., it is available to students and other authorized users. "+
                                "If you select “Delete”, the quiz will be permanently deleted and students will not be able to access it. "+
                                "Deleting a quiz cannot be undone.";
                        }else{
                            modalBody = "If you select “Delete”, the quiz will be permanently deleted. Deleting a quiz cannot be undone.";
                        }
                    }else if("Collection" === scope.content.type){
                        modalHeadline = "Delete Folder?";
                        modalBody = 'Deleting the “' + title + '” Folder will delete the Folder as well as any items stored in it. This action cannot be undone.';
                    }else {
                        modalHeadline = "Delete Media Asset?";
                        modalBody = 'This action cannot be undone.';
                    }
                    $('#delete-modal-single #myModalHeadlineSingle').text(modalHeadline);
                    $('#delete-modal-single .modal-body p').text(modalBody);
                    $("#delete-modal-single").modal('show');
                    scope.selected = e;
                };

                scope.menuDelete = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('menuDelete')
                    }
                    var checkbox = e.target.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('input[type=checkbox]');
                    checkbox.checked = true;

                    scope.deleteItem(e.target);
                }

                scope.openModal = function (type, xid) {
                    if(scope.logEventHandlers) {
                        console.log('openModal')
                    }
                    var contents = [];
                    if (scope.$parent.hit) {
                        console.log('filtered items: ', scope.$parent.hit);

                        scope.$parent.$parent.$parent.$parent.content = {
                            type: type,
                            item: [scope.$parent.hit],
                        };
                    }
                    else {
                        var filteredArray = scope.currentcollection.contents.filter((el) => {
                            return el.xid == xid;
                        });
                        console.log('filtered items: ', filteredArray);

                        scope.$parent.$parent.content = {
                            type: type,
                            item: filteredArray,
                        };
                    }

                    $timeout(function() {
                        $("#cbMakeQuizAvailable").prop('checked', false);
                    }, 100);

                    // Modal is being called empty
                    $("#itemManagementWindow").modal('show')
                        .on('shown.bs.modal', function () {
                            modalFocus('#publishHeading', '#returnTopublishHeading');
                            $('#returnTopublishHeading').on('focus', function () {
                                $('#publishHeading').focus()
                            });
                        });
                };

                scope.deleteItem = function (el) {
                    if(scope.logEventHandlers) {
                        console.log('deleteItem')
                    }
                    var xids = [];
                    var xid = el.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.getAttribute('data-xid');
                    xids.push(xid);

                    var filteredArray = scope.currentcollection.contents.filter((el) => {
                        return xids.some((f) => {
                            return f === el.xid;
                        });
                    });
                    var items = [];
                    var item = {};
                    item.collectionContentDTO = scope.content;
                    item.destinationCollectionId = scope.currentcollection.cid;
                    items.push(item);
                    console.log('filtered items: ', items);
                    var deleteItem = new BaseFileService.DeleteItem({
                       contents: items,
                       totalContents: items.length
                    });
                    deleteItem.$save(function (response) {
                        console.log('deleteItem resp: ', response);
                        scope.$parent.$parent.$parent.render = true;
                    }, function () {
                        });
                }

                var modalFocus = function (first, last) {
                    if(scope.logEventHandlers) {
                        console.log('modalFocus')
                    }
                    var firstItem = $(first),
                        lastItem = $(last);

                    /*set focus on first item*/
                    firstItem.focus();

                    /*redirect last tab to first input*/
                    lastItem.on('keydown', function (e) {
                        if ((e.which === 9 && !e.shiftKey)) {
                            e.preventDefault();
                            firstItem.focus();
                        }
                    });

                    /*redirect first shift+tab to last input*/
                    firstItem.on('keydown', function (e) {
                        if ((e.which === 9 && e.shiftKey)) {
                            e.preventDefault();
                            lastItem.focus();
                        }
                    });
                };

                scope.isEditingViaOverflowMenu = false;

                scope.menuRename = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('menuRename')
                    }

                    scope.isEditingViaOverflowMenu = true;

                    var el = e.target;

                    //Name input text field
                    var itemNameField = el.closest('.caption').querySelector('input.asset-title');

                    //Name text with hover
                    var itemNameText = itemNameField.parentElement.querySelector('div.asset-title');

                    //Name text no hover
                    var itemNameTextNoHover = itemNameField.parentElement.querySelector('div.asset-title-no-hover');

                    var menu = scope.getMenuLocationFromMenuItem(el);

                    //Show Description text without hover
                    var descriptionNoHover = menu.parentElement.parentElement.querySelector('p.description-no-hover');
                    descriptionNoHover.style.display = '';

                    //Hide Description with hover
                    var descriptionText = menu.parentElement.parentElement.querySelector('p.description');
                    descriptionText.style.display = 'none';

                    //Hide all Description textareas
                    $('textarea').hide();

                    //Hide all title inputs
                    $('input[title=text]').hide();

                    //hide Description textarea
                    var descriptionField = menu.parentElement.parentElement.querySelector('textarea');
                    descriptionField.style.display = 'none';

                    //Hide menu
                    menu.style.display = 'none';

                    //Set menu button aria-expanded value
                    $(e.target).parent().parent().parent().parent().parent().children('.menu-icon').attr("aria-expanded","false");

                    //Hide name with hover
                    itemNameText.style.display = 'none';

                    //Hide name no hover
                    itemNameTextNoHover.style.display = 'none';

                    //Display name input
                    itemNameField.classList.remove('ng-hide');
                    itemNameField.style.display = '';
                    itemNameField.focus();
                    itemNameField.setSelectionRange(0, 0);

                    setTimeout(function(){
                        scope.isEditingViaOverflowMenu = false;
                    }, 1000)
                }

                scope.makeDescriptionEditable = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('makeDescriptionEditable')
                    }

                    var focusedElement = document.activeElement;
                    if(
                        focusedElement &&
                        (focusedElement.nodeName === 'INPUT' || focusedElement.nodeName === 'TEXTAREA')
                    ) {
                        $(e.target).parent().parent().parent().find('p.description-no-hover').hide();
                        $(e.target).parent().parent().parent().find('p.description').show();
                    }
                    else {
                        if(scope.isPersistingTitle === false && scope.isKeyboardNavigatingTitle === false) {
                            $(e.target).parent().parent().parent().find('p.description-no-hover').hide();
                            $(e.target).parent().parent().parent().find('p.description').show();
                        }
                    }
                }

                scope.handleTitleNoHoverMouseLeave = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleTitleNoHoverMouseLeave')
                    }

                    //hide title no-hover
                    $(e.target).hide();

                    // set title no-hover value to title text
                    $(e.target).parent().find('div.asset-title').text(
                        $(e.target).text()
                    );

                    //show title text
                    $(e.target).parent().find('div.asset-title:not(div.asset-title-no-hover)').show();
                }

                scope.handleMenuToggleActiveKeyPress = function(e, active) {
                    if(e.which === 13 || e.which === 32) {
                        scope.toggleActive(e, active);
                    }
                }

                scope.toggleActive = function(e, active) {
                    if(scope.logEventHandlers) {
                        console.log('publishItem')
                    }
                    var assetActiveStatusDTO = {
                        assetId: scope.content.xid,
                        active: active,
                    }
                    if (!active) {
                        AssetService.SetActiveStatus.send(assetActiveStatusDTO, function (response) {
                            scope.$parent.$parent.$parent.render = true;
                        });
                    }
                    else {
                        scope.openModal('Publish', scope.content.xid);
                        setTimeout( function(){
                            $("#itemManagementWindow #publishHeading").focus();
                        },500);
                    }
                }

                scope.menuAddDescription = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('menuAddDescription')
                    }
                    scope.isEditingViaOverflowMenu = true;

                    var el = e.target;
                    var itemDescriptionField = el.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('textarea');
                    var itemDescriptionTextList = itemDescriptionField.parentElement.querySelectorAll('p');

                    for (var itemDescriptionText of itemDescriptionTextList) {
                        itemDescriptionText.style.display = 'none';
                    }

                    //Hide all Description textareas
                    $('textarea').hide();

                    //Hide all title inputs
                    $('input[title=text]').hide();

                    itemDescriptionField.style.display = '';
                    itemDescriptionField.focus();
                    itemDescriptionField.scrollTop = 0;
                    itemDescriptionField.setSelectionRange(0, 0);

                    var menu = scope.getMenuLocationFromMenuItem(el);
                    menu.style.display = 'none';
                    $(e.target).parent().parent().parent().parent().parent().children('.menu-icon').attr("aria-expanded","false");

                    setTimeout(function(){
                        scope.isEditingViaOverflowMenu = false;
                    }, 1000)
                }

                scope.handleTitleInputMouseLeave = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleTitleInputMouseLeave')
                    }

                    var titleInput = e.target;
                    var focusedElement = document.activeElement;

                    if(focusedElement && (
                        focusedElement.nodeName === 'TEXTAREA'
                    )) {
                        $(e.target).hide();
                        $(e.target).parent().children('div.asset-title').hide();
                        $(e.target).parent().children('div.asset-title-no-hover').show();
                    } else {
                        if(focusedElement !== titleInput) {
                            if (titleInput.value.length) {
                                if (scope.isPersistingTitle === false && scope.isKeyboardNavigatingTitle === false) {
                                    $(titleInput).hide();
                                    $(titleInput).parent().find('div.asset-title').text(
                                        $(titleInput).val()
                                    );
                                    $(titleInput).parent().find('div.asset-title').hide();
                                    $(titleInput).parent().find('div.asset-title-no-hover').text(
                                        $(titleInput).val()
                                    );
                                    $(titleInput).parent().find('div.asset-title-no-hover').show();
                                }
                            }
                        }

                        scope.makeDescriptionEditable(e);
                    }
                }

                scope.showDescriptionField = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('showDescriptionField')
                    }

                    if(scope.isKeyboardNavigatingDescription === false) {
                        var focusedElement = document.activeElement;

                        if(focusedElement &&
                            (focusedElement.nodeName === 'INPUT' || focusedElement.nodeName === 'TEXTAREA')
                        ) {
                            $(e.target).hide();
                            $(e.target).parent().children('p.description-no-hover').hide();
                            $(e.target).parent().children('textarea.description').show();
                        } else {
                            var el = e.target;
                            var descriptionNoHover = el.parentElement.querySelector('p.description-no-hover');
                            var descriptionField = el.parentElement.querySelector('textarea.description');
                            el.style.display = 'none';

                            //hide input
                            var titleField = descriptionField.parentElement.parentElement.querySelector('input[type=text]');
                            if(titleField) {
                                titleField.style.display = 'none';
                            }

                            //hide text no-hover
                            var titleTextNoHover = descriptionField.parentElement.parentElement.querySelector('div.asset-title-no-hover');
                            if(titleTextNoHover) {
                                titleTextNoHover.style.display = 'none';
                            }

                            //show title
                            var titleText = descriptionField.parentElement.parentElement.querySelector('div.folder-title');
                            if(titleText) {
                                titleText.classList.remove('ng-hide');
                                titleText.style.display = '';
                            }

                            //if focused element is a title input
                            if(focusedElement.classList.contains('asset-title') && focusedElement.nodeName === 'INPUT') {
                                //if focused element is not a Create Folder card
                                if(!focusedElement.classList.contains('create-folder-title-list') &&
                                    !focusedElement.classList.contains('create-folder-title-grid')) {

                                    //hide focused element and show title hoverable
                                    focusedElement.style.display = 'none';

                                    var titleText = focusedElement.parentElement.querySelector('div.folder-title');
                                    if(titleText) {
                                        titleText.classList.remove('ng-hide');
                                        titleText.style.display = '';
                                    }
                                }
                            }

                            //hide all other textareas
                            $('textarea.description').each(function(index, item) {
                                //if it's not the current textarea
                                if(item.parentElement.querySelector('p.description') !== el &&
                                    !item.classList.contains('create-folder-description-list') &&
                                    !item.classList.contains('create-folder-description-grid')) {
                                        $(item).hide();
                                        $(item).parent().children('p.description-no-hover').hide();
                                        $(item).parent().children('p.description').show();
                                }
                            });

                            //hide description no-hover
                            descriptionNoHover.style.display = 'none';

                            //show textarea
                            descriptionField.style.display = '';
                            descriptionField.classList.remove('ng-hide');
                        }
                    }

                    scope.isKeyboardNavigatingDescription = false;
                }

                scope.calculateRowsForTextArea = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('calculateRowsForTextArea')
                    }
                    var el = e.target;
                    var cols = el.getAttribute('cols');
                    var textLength = el.value.length;
                    var rows = Math.ceil(textLength / cols);

                    if(rows < 1) rows = 1;
                    if(rows > 2) rows = 2;

                    el.setAttribute('rows', rows);
                }

                scope.handleDescriptionMouseLeave = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleDescriptionMouseLeave')
                    }

                    var focusedElement = document.activeElement;

                    if(focusedElement &&
                        (focusedElement.nodeName === 'INPUT')
                    ){
                        $(e.target).hide();
                        $(e.target).parent().find('p.description').hide();
                        $(e.target).parent().find('p.description-no-hover').show();
                    }else{
                        if(focusedElement && focusedElement !== e.target) {
                            if(scope.isPersistingDescription === false && scope.isKeyboardNavigatingDescription === false) {
                                $(e.target).hide();
                                $(e.target).parent().find('p.description').hide();
                                $(e.target).parent().find('p.description-no-hover').show();
                            }
                        }
                    }
                }

                scope.handleMetaMouseOver = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleMetaMouseOver')
                    }

                    var el = e.target; //meta
                    if(el.classList.contains('meta')) {
                        var focusedElement = document.activeElement;

                        if(focusedElement && focusedElement.nodeName === 'TEXTAREA') {
                            if(focusedElement === e.target.parentElement.querySelector('textarea.description')) {
                                $(e.target).parent().find('p.description-no-hover').hide();
                                $(e.target).parent().find('p.description').hide();
                            }
                        } else if (
                            focusedElement
                            && focusedElement.nodeName === 'INPUT'
                            && focusedElement.classList.contains('asset-title')
                            && focusedElement === e.target.parentElement.querySelector('input.asset-title')
                        ) {
                            $(e.target).parent().find('div.asset-title-no-hover').hide();
                            $(e.target).parent().find('div.asset-title').hide();
                        } else {
                            $(e.target).parent().find('p.description-no-hover').hide();
                            $(e.target).parent().find('textarea.description').hide();
                            $(e.target).parent().find('p.description').show();
                        }
                    }
                }

                scope.showTitleField = function (e) {
                    if(scope.logEventHandlers) {
                        console.log('showTitleField')
                    }

                    if(scope.isKeyboardNavigatingTitle === false) {
                        var focusedElement = document.activeElement;

                        if(
                            focusedElement &&
                            (focusedElement.nodeName === 'INPUT' || focusedElement.nodeName === 'TEXTAREA')
                        ) {
                            $(e.target).hide();
                            $(e.target).parent().children('div.asset-title-no-hover').hide();
                            $(e.target).parent().children('input.asset-title').show();
                        } else {
                            var el = e.target;
                            var titleNoHover = el.parentElement.querySelector('div.asset-title-no-hover');
                            var titleField = el.parentElement.querySelector('input.asset-title');
                            el.style.display = 'none';

                            //hide all other title fields, except for the create folder card, and show description text
                            $('input.asset-title').each(function(index, item) {
                                if(!$(item).hasClass('create-folder-title-list') && !$(item).hasClass('create-folder-title-grid')) {
                                    $(item).hide();
                                    $(item).parent().children('div.description-no-hover').hide();
                                    $(item).parent().children('div.description').show();
                                }
                            })

                            //if focused element is not the title input inside Create Folder card
                            if(!focusedElement.classList.contains('create-folder-title-list') &&
                                !focusedElement.classList.contains('create-folder-title-grid')) {


                                //if focus is in a description textarea
                                if (focusedElement.classList.contains('description') && focusedElement.nodeName === 'TEXTAREA') {
                                    //display the corresponding Description element
                                    var parentDescription = focusedElement.parentElement.querySelector('p.description');
                                    parentDescription.classList.remove('ng-hide');
                                    parentDescription.style.display = '';
                                }

                            }

                            //hide all textareas and show their corresponding descriptions
                            $('textarea.description').each(function(index, item) {
                                if (!item.classList.contains('create-folder-description-list') && !item.classList.contains('create-folder-description-grid')) {
                                    $(item).hide();
                                    $(item).parent().children('p.description-no-hover').hide();
                                    $(item).parent().children('p.description').show();
                                }
                            });

                            //show corresponding description text
                            $(el).parent().parent().parent().find('p.description-no-hover').hide();
                            $(el).parent().parent().parent().find('p.description').show();

                            //hide all other title fields and display their corresponding texts
                            $('input.asset-title').each(function(index, item) {
                                if(item !== el.parentElement.querySelector('input.asset-title') &&
                                    (!item.classList.contains('create-folder-title-list') && !item.classList.contains('create-folder-title-grid'))) {
                                    $(item).hide();
                                    $(item).parent().children('div.asset-title-no-hover').hide();
                                    $(item).parent().children('div.asset-title:not(.asset-title-no-hover)').show();
                                }
                            });

                            //hide title no-hover
                            titleNoHover.style.display = 'none';

                            //show corresponding title field
                            titleField.style.display = '';
                            titleField.scrollLeft = 0;
                        }
                    }

                    scope.isKeyboardNavigatingTitle = false;
                }

                scope.setCarrotPosition = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('setCarrotPosition')
                    }
                    var el = e.target;
                    if(el.createTextRange) {
                        var range = el.createTextRange();
                        range.move('character', 0);
                        range.select();
                    }
                    else {
                        if(el.selectionStart) {
                            el.focus();
                            el.setSelectionRange(0, 0);
                        }
                        else
                            el.focus();
                    }
                }

                scope.getMenuLocationFromMenuItem = function(el) {
                    if(scope.logEventHandlers) {
                        console.log('getMenuLocationFromMenuItem');
                    }
                    var locations = [
                        {nodeName: 'LI', location: el.parentElement.parentElement},
                        {nodeName: 'IMG', location: el.parentElement.parentElement.parentElement.parentElement.parentElement},
                        {nodeName: 'DIV', location: el.parentElement.parentElement.parentElement},
                        {nodeName: 'SPAN', location: el.parentElement.parentElement.parentElement.parentElement},
                        {nodeName: 'INPUT', location: el.parentElement.parentElement.parentElement.parentElement.parentElement}
                    ];

                    var searchedElement = locations.find(p => p.nodeName === el.nodeName);

                    if(searchedElement) {
                        return searchedElement.location;
                    }

                    return el;
                }

                scope.showMenu = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('showMenu')
                    }

                    var el = e.target;
                    var menu = $(el).parents('div[data-xid]').find('.menu');
                    var isMenuVisible = $(menu).is(':visible');

                    //hide all menus
                    $('.menu').hide();
                    $(".menu-icon").attr("aria-expanded","false");

                    if(menu) {
                        $('textarea').hide();
                        var value = null;
                        $('p.description-no-hover').each(function(index, item){
                            value = $(item).text();
                            value = value.length ? value : 'Enter a description';
                            $(item).text(value);
                            $(item).hide();
                        });

                        $('p.create-folder-description-placeholder').each(function(index, item){
                            value = $(item).text();
                            value = value.length ? value : 'Enter a description';
                            $(item).text(value);
                            $(item).hide();
                        });

                        $('p.description').each(function(index, item) {
                            value = $(item).text();
                            value = value.length ? value : 'Enter a description';
                            $(item).text(value);
                            $(item).show();
                        })

                        $(menu).parent().parent().find('p.description').hide();
                        $(menu).parent().parent().find('p.description-no-hover').removeClass('ng-hide');
                        $(menu).parent().parent().find('p.description-no-hover').show();

                        $('input[type=text]:is(.asset-title):not(.create-folder-title-grid):not(.create-folder-title-list)').hide();
                        $('div.asset-title-no-hover').hide();
                        $('div.asset-title:not(.asset-title-no-hover):not(.create-folder-title-list):not(.create-folder-title-grid):not(.folder-title-no-hover)').show();

                        $(menu).parent().parent().find('div.asset-title-no-hover').hide();
                        $(menu).parent().parent().find('input.asset-title').hide();
                        $(menu).parent().parent().find('div.asset-title:not(.asset-title-no-hover)').show();

                        scope.menuDescriptionText = scope.content.description.trim() === '' ? 'Add Description' : 'Edit Description';

                        if(!isMenuVisible) {
                            $(menu).show();
                        }
                        $(e.target).parent().parent().attr("aria-expanded",!isMenuVisible);

                        setTimeout(() => {
                                if(!isMenuVisible){
                                    $(menu).find('[tabindex="0"]').first().focus();
                                }else{
                                    $(e.target).parent().parent().focus();
                                }
                            }, 100);
                    }
                }

                 scope.hideMenu = function(e) {
                     if(scope.logEventHandlers) {
                         console.log('hideMenu')
                     }
                    var el = e.target;

                    if(el.classList.contains('menu')) {
                        el.style.display = 'none';
                        return;
                    }

                    if(el.nodeName === 'LI') {
                        var menu = el.parentElement.parentElement;
                        if(menu) menu.style.display = 'none';
                    }
                }

                scope.setItemBgColor = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('setItemBgColor')
                    }
                    var checkbox;
                    var el = e.target;
                    if(el.nodeName === 'INPUT') checkbox = el;
                    if(el.nodeName === 'LABEL') checkbox = el.querySelector('input');

                    var container;

                    container = checkbox.parentElement.parentElement.parentElement.parentElement;

                    if(checkbox.checked) {
                        container.style.backgroundColor = scope.cardBgColorOnFocus;
                    } else {
                        container.style.backgroundColor = "#FFFFFF";
                    }
                }

                scope.selectCheckbox = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('selectCheckbox')
                    }
                    e.preventDefault();
                    if(e.keyCode === 13 || e.keyCode === 32) {
                        var label = e.target;
                        var checkbox = label.querySelector('input[type=checkbox]');
                        checkbox.checked = !checkbox.checked;
                        scope.setItemBgColor(e);
                        scope.manageCheckAllState(e);
                    }
                }

                scope.handleMenuIconKeyDown = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleMenuIconKeyDown')
                    }

                    if(e.which === 9 && !e.shiftKey) {
                        e.preventDefault();
                        var menuIcon = e.target;
                        var menu = $(menuIcon).parent().children('.menu');

                        if(!$(menu).is(':visible')) {
                            if(scope.activeview === 'grid') {
                                $(menuIcon).parent().parent().find('p.description').hide();
                                $(menuIcon).parent().parent().find('p.description-no-hover').hide();
                                $(menuIcon).parent().parent().find('textarea.description').show();
                                $(menuIcon).parent().parent().find('textarea.description').focus();
                                $(menuIcon).parent().parent().find('textarea.description').scrollTop(0);
                            } else if(scope.activeview === 'list') {
                                //look for star or next card
                                var menuIcon = e.target;
                                var star = menuIcon.parentElement.querySelector('.star');

                                if(star) {
                                    e.preventDefault();
                                    star.focus();
                                } else {
                                    //get corresponding card
                                    var card = menuIcon.parentElement.parentElement.parentElement.parentElement;
                                    var cardIndex;

                                    //check if there's a next card to focus
                                    var assetList = card.parentElement.parentElement.querySelectorAll('.item.pnp-item:not(#inlineFolderCreate)');

                                    for (var i = 0; i < assetList.length; i++) {
                                        if (assetList[i] === card.parentElement) {
                                            cardIndex = i;
                                        }
                                    }

                                    //if it's not the last card, focus on next
                                    var indexToFocus = 0;
                                    if (cardIndex < assetList.length - 1) {
                                        indexToFocus = cardIndex + 1;

                                        //focus on checkbox
                                        e.preventDefault();
                                        assetList[indexToFocus].querySelector('input[type=checkbox]').parentElement.focus();

                                    } else {
                                        //it's the last card

                                        //check if pagination exists
                                        var pagination = document.querySelector('ul.pagination');
                                        if (pagination) {
                                            //focus on first pagination link
                                            e.preventDefault();
                                            document.querySelector('ul.pagination li.page-number a').focus();
                                        } else {
                                            //focus on address bar

                                            //As it is the last focusable element in the screen, the next one will be:
                                            //LMS: the app container then the web browser address bar.
                                            //Standalone: the web browser address bar.
                                        }
                                    }
                                    e.stopPropagation();
                                }

                            }
                        } else {
                            //menu is visible
                            $(menu).find('[tabindex="0"]').first().focus();
                        }

                    } else if(e.which === 9 && e.shiftKey) {
                        e.preventDefault();
                        if(scope.activeview === 'list') {
                            $(e.target).parent().parent().find('p.description-no-hover').hide();
                            $(e.target).parent().parent().find('p.description').hide();
                            $(e.target).parent().parent().find('textarea.description').show();
                            $(e.target).parent().parent().find('textarea.description').focus();
                            $(e.target).parent().parent().find('textarea.description').scrollTop(0);

                        } else if(scope.activeview === 'grid') {
                            $(e.target).parent().parent().find('div.asset-title').hide();
                            $(e.target).parent().parent().find('div.asset-title-no-hover').hide();
                            $(e.target).parent().parent().find('input.asset-title').show();
                            $(e.target).parent().parent().find('input.asset-title').focus();
                        }
                    }
                }

                scope.isKeyboardNavigatingTitle = false;
                scope.handleTitleInputKeyDown = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleTitleInputKeyDown')
                    }
                    if(e.which === 9) {
                        scope.isKeyboardNavigatingTitle = true;
                        e.preventDefault();

                        if(!e.shiftKey) {
                        var input = e.target;
                        if(scope.activeview === 'grid') {
                            $(input).hide();
                            $(input).parent().children('div.folder-title').show();
                            $(input).parent().children('.menu-icon').focus();
                        } else if(scope.activeview === 'list') {
                            $(input).hide();
                            $(input).parent().parent().parent().find('div.asset-title-no-hover').hide();
                                $(input).parent().parent().parent().find('div.asset-title').show();
                            $(input).parent().parent().parent().find('p.description').hide();
                            $(input).parent().parent().parent().find('p.description-no-hover').hide();
                            $(input).parent().parent().parent().find('textarea.description').show();
                            $(input).parent().parent().parent().find('textarea.description').focus();
                            $(input).parent().parent().parent().find('textarea.description').scrollTop(0);
                        }
                        } else if(e.shiftKey) {
                        if(scope.activeview === 'grid') {
                            $(e.target).hide();
                            $(e.target).parent().children('div.asset-title-no-hover').hide();
                            $(e.target).parent().children('div.asset-title:first()').show();
                            $(e.target).parent().children('.asset-type-icon').focus();
                        } else if(scope.activeview === 'list') {
                            $(e.target).hide();
                            $(e.target).parent().children('div.asset-title-no-hover').hide();
                                $(e.target).parent().children('div.asset-title').show();
                            $(e.target).parent().children('.asset-type-icon').focus();
                            }
                        }
                    }
                }

                scope.handleDescriptionTextareaKeyDown = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleDescriptionTextareaKeyDown')
                    }
                    var descriptionTextarea = e.target;
                    if(e.which === 9 && !e.shiftKey) {
                        e.preventDefault();
                        $(descriptionTextarea).hide();
                        $(descriptionTextarea).parent().find('p.description').hide();
                        $(descriptionTextarea).parent().find('p.description-no-hover').show();
                        $(descriptionTextarea).parent().parent().parent().parent().find('label.card-checkbox').focus();
                    } else if(e.which === 9 && e.shiftKey) {
                        e.preventDefault();
                        if(scope.activeview === 'grid') {
                            $(descriptionTextarea).hide();
                            $(descriptionTextarea).parent().children('p.description-no-hover').hide();
                            $(descriptionTextarea).parent().children('p.description').show();
                            $(descriptionTextarea).parent().parent().find('.menu-icon').focus();
                        } else if (scope.activeview === 'list') {
                            $(descriptionTextarea).hide();
                            $(descriptionTextarea).parent().children('p.description-no-hover').hide();
                            $(descriptionTextarea).parent().children('p.description').show();
                            $(descriptionTextarea).parent().parent().parent().find('.menu-icon').focus();
                        }
                    }
                }

                scope.handleCheckboxKeyDown = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleCheckboxKeyDown')
                    }
                    var checkbox = e.target;
                    if(e.which === 9 && !e.shiftKey) {
                        // e.preventDefault();

                        //if there's a star, focus in it
                        if(scope.activeview === 'grid') {
                            var star = checkbox.parentElement.querySelector('div.star');
                            if(star) {
                                e.preventDefault();
                                star.focus();
                            } else {
                                //get corresponding card
                                var card = checkbox.parentElement.parentElement.parentElement;
                                var cardIndex;

                                //check if there's a next card to focus
                                var assetList = card.parentElement.parentElement.querySelectorAll('.item.pnp-item:not(#inlineFolderCreate)');

                                for(var i = 0; i < assetList.length; i++) {
                                    if(assetList[i] === card.parentElement) {
                                        cardIndex = i;
                                    }
                                }

                                //if it's not the last card, focus on next
                                var indexToFocus = 0;
                                if(cardIndex < assetList.length - 1) {
                                    indexToFocus = cardIndex + 1;
                                    e.preventDefault();
                                    assetList[indexToFocus].querySelector('.asset-image').focus();
                                } else {
                                    //it's the last card

                                    //check if pagination exists
                                    var pagination = document.querySelector('ul.pagination');
                                    if(pagination) {
                                        e.preventDefault();
                                        //focus on first pagination link
                                        document.querySelector('ul.pagination li.page-number a').focus();
                                    } else {
                                        //there's no pagination
                                        //It is the last focusable element on the page
                                        //Next element will be the browser address bar
                                    }
                                }
                            }
                        }

                    } else if (e.which === 9 && e.shiftKey) {
                        if(scope.activeview === 'grid') {
                            e.preventDefault();
                            $(checkbox).parent().parent().find('p.description-no-hover').hide();
                            $(checkbox).parent().parent().find('p.description').hide();
                            $(checkbox).parent().parent().find('textarea').show();
                            $(checkbox).parent().parent().find('textarea').focus();
                            $(checkbox).parent().parent().find('textarea').scrollTop(0);
                        }
                    }
                }

                scope.handleStarKeyDown = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleStarKeyDown')
                    }
                    var checkbox = e.target;
                    //get corresponding card
                    var card = checkbox.parentElement.parentElement.parentElement.parentElement;
                    var cardIndex;

                    //check if there's a new card to focus
                    var assetList = card.parentElement.parentElement.querySelectorAll('.item.pnp-item:not(#inlineFolderCreate)');

                    for(var i = 0; i < assetList.length; i++) {
                        if(assetList[i] === card.parentElement) {
                            cardIndex = i;
                        }
                    }

                    //if it's not the last card, focus on next
                    var indexToFocus = 0;
                    if(cardIndex < assetList.length - 1) {
                        indexToFocus = cardIndex + 1;
                        assetList[indexToFocus].querySelector('.menu-icon').focus();
                    } else {
                        //it's the last card

                        //check if pagination exists
                        var pagination = document.querySelector('ul.pagination');
                        if(pagination) {
                            //focus on first pagination link
                            document.querySelector('ul.pagination li.page-number a').focus();
                        } else {
                            //focus on first card
                            assetList[0].querySelector('.menu-icon').focus();
                        }

                    }
                }

                scope.handleMenuIconKeyPress = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleMenuIconKeyPress')
                    }
                    if(e.which === 13 || e.which === 32) {
                        e.preventDefault();
                        var el = e.target;
                        var menu = $(el).parent().children('.menu');
                        if(!$(menu).is(':visible')) {
                            $('.menu').hide();
                            $(".menu-icon").attr("aria-expanded","false");
                            $(menu).show();
                            scope.menuDescriptionText = scope.content.description.trim() === '' ? 'Add Description' : 'Edit Description';
                            $(e.target).attr("aria-expanded","true");
                        } else {
                            $(menu).hide();
                            $(e.target).attr("aria-expanded","false");
                        }
                        setTimeout(() => {
                                if($(menu).is(':visible')){
                                    $(menu).find('[tabindex="0"]').first().focus();
                                }else{
                                    $(e.target).focus();
                                }
                            }, 100);
                    }
                }

                scope.handleLastMenuItemKeyDown = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleLastMenuItemKeyDown')
                    }
                    if(e.which === 9 && !e.shiftKey) {
                        e.preventDefault();
                        $(e.target).parent().parent().parent().children('.menu-icon').focus();
                    }
                    scope.closeMenuAndFocusOnMenuIcon(e);
                }

                scope.handleMenuRenameKeyPress = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleMenuRenameKeyPress')
                    }
                    if(e.which === 13 ||  e.which === 32) {
                        scope.menuRename(e);
                    }
                }

                scope.closeMenuAndFocusOnMenuIcon = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('closeMenuAndFocusOnMenuIcon')
                    }
                    if(e.which === 27) {
                        $('.menu').hide();
                        $(".menu-icon").attr("aria-expanded","false");
                        var menuButton = $(e.target).parent().parent().parent().children('.menu-icon');
                        //if menuButton does not exist then target must be availibility switch that requires another search
                        if(!menuButton.length){
                            menuButton = $(e.target).parent().parent().parent().parent().parent().parent().children('.menu-icon');
                        }
                        menuButton.focus();
                    }
                }

                scope.handleMenuEditDescriptionKeyPress = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleMenuEditDescriptionKeyPress')
                    }
                    if(e.which === 13 || e.which === 32) {
                        e.preventDefault();
                        scope.menuAddDescription(e);
                    }
                }

                scope.handleMenuMoveKeyPress = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleMenuMoveKeyPress')
                    }
                    if(e.which === 13 || e.which === 32) {
                        scope.menuMove(e);
                        var closeBtn = document.querySelector('#itemManagementWindow .modal-dialog .btn-blank.btn-close');

                        setTimeout(function() {
                            closeBtn.focus();
                        }, 1200);
                    }
                }

                scope.handleMenuCopyKeyPress = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleMenuCopyKeyPress')
                    }
                    if(e.which === 13 || e.which === 32) {
                        scope.menuCopy(e);
                        var closeBtn = document.querySelector('#itemManagementWindow .modal-dialog .btn-blank.btn-close');

                        setTimeout(function() {
                            closeBtn.focus();
                        }, 1200);
                    }
                }

                scope.handleMenuDeleteKeyPress = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleMenuDeleteKeyPress')
                    }
                    if(e.which === 13 || e.which === 32) {
                        scope.confirmDelete(e);
                    }
                }

                scope.handleMenuQuizKeyPress = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleMenuQuizKeyPress')
                    }
                    if(e.which === 13 || e.which === 32) {
                        scope.createQuiz(e);
                    }
                }

                scope.handleStarKeyPress = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleStarKeyPress')
                    }
                    if(e.which === 13 || e.which === 32) {
                        scope.toggleFavorite(scope.content);
                    }
                }

                scope.isKeyboardNavigatingDescription = false;
                scope.handleDescriptionKeyDown = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleDescriptionKeyDown')
                    }
                    if(e.which === 9) {
                        scope.isKeyboardNavigatingDescription = true;
                        e.preventDefault();
                        if(!e.shiftKey) {
                            //for grid view, we don't need a handler as it will follow the natural browser navigation.
                            if(scope.activeview === 'list') {
                                //hide desc
                                $(e.target).hide();
                                $(e.target).parent().find('p.description-no-hover').hide();
                                $(e.target).parent().find('p.description').show();
                                $(e.target).parent().parent().parent().find('.menu-icon').focus();
                            }
                        } else if (e.shiftKey) {
                            if (scope.activeview === 'list') {
                                $(e.target).hide();
                                $(e.target).parent().children('p.description-no-hover').hide();
                                $(e.target).parent().children('p.description').show();
                                $(e.target).parent().parent().find('div.asset-title').hide();
                                $(e.target).parent().parent().find('div.asset-title-no-hover').hide();
                                $(e.target).parent().parent().find('input.asset-title').show();
                                $(e.target).parent().parent().find('input.asset-title').focus();
                            }
                        }
                    }
                }

                scope.handleDescriptionMouseOver = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleDescriptionMouseOver')
                    }

                    scope.calculateRowsForTextArea(e);
                    var focusedElement = document.activeElement;
                    if(focusedElement &&
                        (focusedElement.nodeName === 'INPUT')
                    ){
                        //do something
                    } else {
                        var el = e.target;
                        el.scrollLeft = 0;
                        el.scrollTop = 0;

                        //guarantee that the title will be hoverable
                        if(scope.activeview === 'list') {
                            $(el).parent().parent().find('div.asset-title-no-hover').hide();
                            $(el).parent().parent().find('input.asset-title').hide();
                            $(el).parent().parent().find('div.asset-title').show();
                        }
                    }
                }

                scope.handleThumbnailKeyPress = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleThumbnailKeyPress')
                    }
                    if(e.which === 13 || e.which === 32) {
                        scope.openContent();
                    }
                }

                scope.editQuiz = function () {
                    AssetService.EditQuiz.get(
                        {
                            quizId: scope.content.quizId,
                        },
                        function (response) {
                            scope.openContent();
                        }
                    );
                };

                scope.handleEditQuizKeyPress = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleEditQuizKeyPress')
                    }
                    if(e.which === 13 || e.which === 32) {
                        scope.editQuiz();
                    }
                }

                scope.handleThumbnailKeyDown = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleThumbnailKeyDown')
                    }
                    if(e.which === 9 && !e.shiftKey) {
                        e.preventDefault();
                        if(scope.activeview === 'list') {
                            $(e.target).parent().find('.asset-type-icon').focus();
                        }
                    }
                }

                scope.handleMediaIconKeyDown = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleMediaIconKeyDown')
                    }
                    if(e.which === 9 && !e.shiftKey) {
                        if(!scope.hasWriteInACL) {
                            if($(e.target).parents('[data-xid]').find('.star').length) {
                                e.preventDefault();
                                $(e.target).parents('[data-xid]').find('.star').focus();
                            }
                        } else {
                            e.preventDefault();
                            $(e.target).parent().find('div.asset-title').hide();
                            $(e.target).parent().find('div.asset-title-no-hover').hide();
                            $(e.target).parent().find('input.asset-title').show();
                            $(e.target).parent().find('input.asset-title').focus();
                        }

                    }
                }

                scope.handleMediaIconMouseOver = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleMediaIconMouseOver')
                    }
                    if(scope.activeview === 'list') {
                        //guarantee that the title will be hoverable
                        $(e.target).parent().find('div.asset-title-no-hover').hide();
                        $(e.target).parent().find('input.asset-title').hide();
                        $(e.target).parent().find('div.asset-title').show();
                    }
                }

                scope.handleDescriptionTextareaClick = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleDescriptionTextareaClick')
                    }

                    if(scope.lastFocusedDescription) {
                        if(
                            scope.lastFocusedDescription.classList.contains('create-folder-description-grid') ||
                            scope.lastFocusedDescription.classList.contains('create-folder-description-list')
                        ) {
                            if(scope.lastFocusedDescription.nodeName === 'TEXTAREA') {
                                scope.lastFocusedDescription.style.display = 'none';
                                scope.lastFocusedDescription.parentElement.querySelector('p.description-no-hover').style.display = 'none';
                                var descriptionPlaceholder = scope.lastFocusedDescription.parentElement.querySelector('p.create-folder-description-placeholder');
                                descriptionPlaceholder.style.display = 'none';
                                var descriptionText = scope.lastFocusedDescription.parentElement.querySelector('p.description');
                                descriptionText.style.display = '';
                                descriptionText.innerHTML = descriptionText.innerHTML.trim() === '' ? 'Enter a description' : descriptionText.innerHTML;
                            }
                        }
                    }
                }

                scope.handleDescriptionNoHoverMouseLeave = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleDescriptionNoHoverMouseLeave')
                    }
                    scope.makeDescriptionEditable(e);
                }

                $('textarea.description').focus(function(e) {
                    scope.lastFocusedDescription = e.target;
                })

                scope.persistNewFolderTitle = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('persistNewFolderTitle')
                    }

                    //if Create Folder card is visible
                    if($('.create-folder-title-grid').css('display') && $('.create-folder-title-grid').css('display') !== 'none') {
                        scope.persistTitle(document.querySelector('.create-folder-title-grid'), true);
                    }

                    if($('.create-folder-title-list').css('display') && $('.create-folder-title-list').css('display') !== 'none') {
                        scope.persistTitle(document.querySelector('.create-folder-title-list'), true);
                    }
                }

                scope.handleInputTitleFocus = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleInputTitleFocus')
                    }

                    //save content on scope
                    scope.currentTitle = e.target.value;
                    scope.persistNewFolderTitle(e);
                    scope.hideCFDescriptionFields();
                }

                scope.hideCFDescriptionFields = function() {
                    var elementSelector = scope.activeview === 'grid' ? '.create-folder-description-grid' : '.create-folder-description-list';

                    $(elementSelector).hide();
                    $(elementSelector).parent().children('p.description').hide();
                    $(elementSelector).parent().children('p.create-folder-description-placeholder').show();
                }

                scope.handleDescriptionTextareaFocus = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleDescriptionTextareaFocus')
                    }

                    scope.currentDescription = e.target.value;
                    scope.hideCFDescriptionFields();
                }

                scope.handleInputTitleBlur = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleInputTitleBlur')
                    }

                    var title = $(e.target).val().trim();

                    var titleValue = title.length ? title : (scope.content.type === 'Collection' ? 'Untitled Folder' : 'Untitled Asset');
                    var untitled;

                    // Count the Untitled Items
                    if(titleValue === 'Untitled Folder' || titleValue === 'Untitled Asset') {
                        var countFolders = 1;
                        var countAssets = 1;

                        $.each(scope.currentcollection.contents, function (k, v) {
                            if (v.title.includes('Untitled Folder')) {
                                countFolders++;
                            }

                            if (v.title.includes('Untitled Asset')) {
                                countAssets++;
                            }
                        });

                        var numFolders = pad(countFolders);
                        var numAssets = pad(countAssets);

                        if(titleValue === 'Untitled Folder') {
                            untitled = numFolders != '01' ? 'Untitled Folder ' + numFolders : 'Untitled Folder';
                        }

                        if(titleValue === 'Untitled Asset') {
                            untitled = numAssets != '01' ? 'Untitled Asset ' + numAssets : 'Untitled Asset';
                        }
                    }

                    var newTitle = untitled ? untitled : titleValue;
                    scope.content.title = newTitle;

                    if(newTitle !== scope.currentTitle) {
                        var updateItem = new BaseFileService.UpdateItem({
                            collectionContentDTO: scope.content,
                            destinationCollectionId: scope.content.xid
                        });

                        updateItem.$save(function (response) {
                            console.log('updateItem resp: ', response);
                            showTitleText(e.target, newTitle);
                        }, function () {});
                    } else {
                        showTitleText(e.target, newTitle);
                    }
                }

                var showTitleText = function(el, value) {
                    if(scope.logEventHandlers) {
                        console.log('showTitleText')
                    }

                    $(el).hide();
                    $(el).val(value);
                    $(el).parent().children('div.asset-title-no-hover').hide();
                    $(el).parent().children('div.asset-title-no-hover').text(value);
                    $(el).parent().children('div.asset-title').text(value);
                    $(el).parent().children('div.asset-title:not(.asset-title-no-hover)').show();
                }

                scope.handleDescriptionTextareaBlur = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleDescriptionTextareaBlur')
                    }

                    var description = $(e.target).val().trim();

                    if(description != scope.currentDescription) {
                        var updateItem = new BaseFileService.UpdateItem({
                            collectionContentDTO: scope.content,
                            destinationCollectionId: scope.content.xid
                        });

                        updateItem.$save(function (response) {
                            console.log('updateItem resp: ', response);
                            showDescriptionText(e.target, description);
                        }, function () {
                        });
                    }  else {
                        showDescriptionText(e.target, description);
                    }
                }

                var showDescriptionText = function(el, value) {
                    if(scope.logEventHandlers) {
                        console.log('showDescriptionText')
                    }

                    value = value.length ? value : 'Enter a description';

                    $(el).hide();
                    $(el).parent().children('p.description-no-hover').hide();
                    $(el).parent().children('p.description-no-hover').text(value);
                    $(el).parent().children('p.description').text(value);
                    $(el).parent().children('p.description').show();
                }

                scope.handleItemCheckboxClick = function(e) {
                    if(scope.logEventHandlers) {
                        console.log('handleItemCheckboxClick')
                    }

                    scope.setItemBgColor(e);
                    scope.manageCheckAllState(e);
                }

                scope.logEventHandlers = false;
            }
        }
    }]);
